export type CapsuleToolbarProps = {
  children: React.ReactNode;
};

export const CapsuleToolbar = ({ children }: CapsuleToolbarProps) => (
  <div className="absolute -right-2 -top-3 z-capsule-toolbar flex flex-row-reverse gap-1">
    {children}
  </div>
);
